module.exports = __webpack_public_path__ + "img/Cuban Sandwich-Chicken.35ec2c6a.jpg";